import React from 'react'
import { Navigate, Route, Routes} from 'react-router-dom'

import { CampaignsDashboardPage, CampaignsDetailPage, CampaignsCreatePage } from '../components'

export const CampaignsRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<CampaignsDashboardPage />} />
      <Route path="/new" element={<CampaignsCreatePage />} />
      <Route path="/:campaignId" element={<CampaignsDetailPage />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  )
}
